// config
import * as http from 'utils/http';
import config from 'config';

const launchOffer = async ({ routeId, dto }) => {
  return http.post(`${config.API_URL}fleet/routes/${routeId}/auctions/`, dto);
};

export default launchOffer;
